import React from 'react'

interface SparkIconProps {
  className?: string
  style?: React.CSSProperties
}

// Four-point AI sparkle.
// One of the alternative icon styles available on Growth+ plans.
export const SparkIcon: React.FC<SparkIconProps> = ({ className, style }) => {
  return (
    <span
      className={className}
      style={{ ...style, display: 'inline-block', lineHeight: 0 }}
    >
      <svg width="100%" height="100%" viewBox="0 0 24 24" fill="currentColor" stroke="none">
        <path d="M12 2l1.9 6.6L20.5 10.5l-6.6 1.9L12 19l-1.9-6.6L3.5 10.5l6.6-1.9L12 2z" />
        <circle cx="19" cy="18.5" r="1.4" />
        <circle cx="5" cy="5.5" r="1" />
      </svg>
    </span>
  )
}
